module.exports = __webpack_public_path__ + "img/logo.a30ba1bb.png";